"use client";

import { Dialog, Transition } from "@headlessui/react";
import { FC, Fragment } from "react";
import logo from "../../../assets/images/logo.svg";
import closeIcon from "../../../assets/images/close.png";
import Image from "next/image";

export interface ModalSuccessContact {
  open: boolean;
  onClose: () => void;
}

export const ModalSuccessContact: FC<ModalSuccessContact> = ({
  open,
  onClose,
}) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative"
        style={{ zIndex: 1000 }}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-75" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative bg-background-white flex justify-center items-center w-full h-[400px] lg:h-[500px] 2xl:h-[680px] max-w-xl lg:max-w-6xl 2xl:max-w-7xl transform overflow-hidden bg-my-beige-claire p-6 text-left align-middle shadow-xl transition-all">
                <div
                  onClick={onClose}
                  className="absolute top-[16px] right-[16px] lg:top-[24px] lg:right-[24px] cursor-pointer"
                >
                  <Image
                    src={closeIcon}
                    className="w-[32px] h-auto"
                    alt="close"
                  />
                </div>
                <div className="flex flex-col items-center">
                  <Image
                    src={logo}
                    className="w-[400px] sm:w-[400px] lg:w-[500px] h-auto"
                    alt="logo"
                  />
                  <div className="mt-[64px]">
                    <p className="text-brand-1 text-center text-[28px] lg:text-2xl font-apollo">
                      Demande envoyée.
                    </p>
                    <p className="text-center font-poppins text-sm lg:text-base mt-[16px]">
                      Notre équipe d&apos;experts vous recontacte incessamment
                      sous peu.
                    </p>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
